export default "__VITE_ASSET__BqabNcbm__"